






















import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import TabContent from './PlanEditResultTabContent.vue';
import {flatten} from 'lodash';
import {cloneDeep} from 'lodash';
import PlanEditResultConfigTabTypesEnum from '@/enums/PlanEditResultConfigTabTypesEnum';
import {mapState} from 'vuex';
import {WarehouseDescription} from '@/models/PlanEditModel';
import PlanEditResultModel from '@/models/PlanEditResultModel';
import {PlanEditResultConfigTab} from '@/models/PlanEditResultConfigModel';
import PlanEditResultConfigComponentsEnum from '@/enums/PlanEditResultConfigComponentsEnum';

@Component({
    components: {
        TabContent,
    },
    computed: {
        ...mapState('planEdit', ['warehouseVeneerDescriptions', 'warehousePlywoodDescriptions']),
        ...mapState('planEditResult', ['result']),
    },
})
export default class Tabs extends Vue {
    @Prop() tabs!: PlanEditResultConfigTab[];
    @Prop() depth!: number;
    @Prop() route!: string;
    @Prop() tabData!: any;

    private tabIndex: number = -1;
    private tab: PlanEditResultConfigTab | null = null;
    private invalidRouteData: boolean = false;
    private localRoute: string | undefined = '';
    private childRoute: string | undefined = '';

    public warehouseVeneerDescriptions!: WarehouseDescription[];
    public warehousePlywoodDescriptions!: WarehouseDescription[];
    public result!: PlanEditResultModel;

    get realTabs() {
        return flatten(
            this.tabs.map((tab, index) => {
                let item = cloneDeep(tab);
                if (item.type === PlanEditResultConfigTabTypesEnum.User) {
                    item.tabConfigIndex = index;
                    return item;
                }
                return this.getSpecificTabs(item, index) as [];
            }),
        );
    }

    get hasSubTabs() {
        return !!(
            this.tab && this.tab.content.find(item => item.componentKey === PlanEditResultConfigComponentsEnum.Tabs)
        );
    }

    get tabKey() {
        return this.tab ? this.tab.name + this.tabIndex : '';
    }

    get localTabData() {
        return this.tabData ? Object.assign({}, this.tabData, this.tab?.data) : this.tab?.data;
    }

    @Watch('route', {immediate: true})
    onRouteChange(value: string) {
        let routeData = this.parseRoute(value);
        if (routeData) {
            this.localRoute = routeData[0];
            if (this.localRoute) this.childRoute = this.route.replace(this.localRoute, '/');
            else this.childRoute = '';
        }
    }

    @Watch('tabIndex')
    onTabIndexChange(value: number, oldValue: number) {
        let tab = this.realTabs.find((item, index) => index === value);
        if (tab) {
            this.tab = tab;
            this.$emit('update:route', `/${tab.tabConfigIndex}/${value}${this.hasSubTabs ? this.childRoute : ''}`);
        }
    }

    created() {
        this.tabIndex = this.getActualTab();
    }

    activated() {
        if (!this.hasSubTabs) this.$emit('update:route', `/${this.tab?.tabConfigIndex}/${this.tabIndex}`);
    }

    getSpecificTabs(tab: PlanEditResultConfigTab, tabConfigIndex: number) {
        switch (tab.type) {
            case PlanEditResultConfigTabTypesEnum.Equipment:
                return this.result.EquipmentTypes.map(type => ({
                    name: type.Name,
                    data: {
                        idEquipmentType: type.Id,
                        idEquipmentCategory: type.IdEquipmentCategory,
                    },
                    type: PlanEditResultConfigTabTypesEnum.Equipment,
                    content: tab.content,
                    tabConfigIndex,
                }));
            case PlanEditResultConfigTabTypesEnum.Shift:
                return this.result.Shifts.map(shift => ({
                    name: shift.Name,
                    data: {
                        shiftIndex: shift.ShiftIndex,
                    },
                    type: PlanEditResultConfigTabTypesEnum.Shift,
                    content: tab.content,
                    tabConfigIndex,
                }));
            case PlanEditResultConfigTabTypesEnum.WarehouseVeneer:
                return this.warehouseVeneerDescriptions.map(wv => ({
                    name: wv.Description,
                    data: {
                        idWarehouseVeneer: wv.Id,
                    },
                    type: PlanEditResultConfigTabTypesEnum.WarehouseVeneer,
                    content: tab.content,
                    tabConfigIndex,
                }));
            case PlanEditResultConfigTabTypesEnum.WarehousePlywood:
                return this.warehousePlywoodDescriptions.map(wp => ({
                    name: wp.Description,
                    data: {
                        idWarehousePlywood: wp.Id,
                    },
                    type: PlanEditResultConfigTabTypesEnum.WarehousePlywood,
                    content: tab.content,
                    tabConfigIndex,
                }));
            default:
                return [];
        }
    }

    async onTabClick(index: number) {
        if (this.tabIndex === index) return;
        this.tabIndex = index;
    }

    getActualTab() {
        if (this.route) {
            let routeData: any = this.parseRoute(this.route);
            if (routeData) {
                let {typeIndex, index} = routeData?.groups;
                let tabIndex = this.realTabs.findIndex((item, i) => i == index && item.tabConfigIndex == typeIndex);
                if (tabIndex !== -1) return tabIndex;
            }
        }
        return 0;
    }

    parseRoute(route: string) {
        return route.match(/^\/?(?<typeIndex>\d+)\/(?<index>\d+)\/?/);
    }

    onUpdateRoute(route: string) {
        return this.$emit('update:route', `/${this.tab?.tabConfigIndex}/${this.tabIndex}${route}`);
    }
}
